import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inputCommaSepreated',
  pure: false
})
export class InputCommaSepreatedPipe implements PipeTransform {

  transform(value: number | string, minFractionDigits: number = 0, maxFractionDigits: number = 2, locale: string = 'en'): string {
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: minFractionDigits,
        maximumFractionDigits: maxFractionDigits
    }).format(Number(value));
}

}
